import { useEffect, useState } from "react";
import { pollProgress } from "./webProgressPoll";

/**
 * Subscribe to a web progress endpoint while `url` is non-null, returning the
 * latest polled payload (or null). Pass `null` to deactivate — the caller gates
 * this on web-mode + an operation being in flight, e.g.:
 *
 *   const progress = useProgressPoll<ExportProgress>(
 *     !isTauri() && busy ? `/api/get_export_progress?config_name=${cfg}` : null,
 *   );
 *
 * The poll stops and the value resets to null when `url` becomes null or the
 * component unmounts. Thin React wrapper over the tested `pollProgress`.
 */
export function useProgressPoll<T>(url: string | null): T | null {
  const [value, setValue] = useState<T | null>(null);
  useEffect(() => {
    if (!url) {
      setValue(null);
      return;
    }
    const stop = pollProgress<T>(url, setValue);
    return () => {
      stop();
      setValue(null);
    };
  }, [url]);
  return value;
}
